export var actionsWrap = {
  '& > div': {
    marginBottom: '0.4em',
    width: '100%',
    '&:last-of-type': {
      marginBottom: 0
    }
  }
};